const DEFAULT_API_URL = 'http://localhost:3001/api';

const normalizeApiBaseUrl = (rawUrl?: string): string => {
  const initial = (rawUrl || DEFAULT_API_URL).trim().replace(/\/+$/, '');

  try {
    const parsed = new URL(initial);
    const pathname = parsed.pathname.replace(/\/+$/, '');

    if (!pathname || pathname === '/') {
      parsed.pathname = '/api';
    } else if (!pathname.endsWith('/api')) {
      parsed.pathname = `${pathname}/api`;
    } else {
      parsed.pathname = pathname;
    }

    return parsed.toString().replace(/\/+$/, '');
  } catch {
    return initial.endsWith('/api') ? initial : `${initial}/api`;
  }
};

export const API_BASE_URL = normalizeApiBaseUrl(import.meta.env.VITE_API_URL);